module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/create-bol2/create-bol2.component.css
// module id = ./src/app/create-bol2/create-bol2.component.css
// module chunks = main